import React, { useState } from 'react'

import { IconButton, Menu, MenuItem } from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'

import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import SettingsIcon from '@material-ui/icons/Settings'
import HelpIcon from '@material-ui/icons/Help'
import LibraryBooksOutlinedIcon from '@material-ui/icons/LibraryBooksOutlined'

export default function ({
  onClickConfig,
  onClickHelp,
  onClickNews,
  onClickLogout,
}) {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const renderMenu = () => {
    return (
      <Menu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClick={handleClose}
        onClose={handleClose}
      >
        <MenuItem onClick={onClickConfig}>
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Configurações" />
        </MenuItem>

        <MenuItem onClick={onClickHelp}>
          <ListItemIcon>
            <HelpIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Documentação" />
        </MenuItem>

        <MenuItem onClick={onClickNews}>
          <ListItemIcon>
            <LibraryBooksOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Destaques e Notícias" />
        </MenuItem>

        <MenuItem onClick={onClickLogout}>
          <ListItemIcon>
            <ExitToAppIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Sair" />
        </MenuItem>
      </Menu>
    )
  }

  return (
    <React.Fragment>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>

      {renderMenu()}
    </React.Fragment>
  )
}
